import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import * as aria from '../../../base/browser/ui/aria/aria.js';
import { Disposable, toDisposable, DisposableStore } from '../../../base/common/lifecycle.js';
import { ICodeEditorService } from '../../browser/services/codeEditorService.js';
import { CodeEditorWidget } from '../../browser/widget/codeEditorWidget.js';
import { DiffEditorWidget } from '../../browser/widget/diffEditorWidget.js';
import { InternalEditorAction } from '../../common/editorAction.js';
import { IEditorWorkerService } from '../../common/services/editorWorkerService.js';
import { StandaloneKeybindingService, applyConfigurationValues } from './simpleServices.js';
import { IStandaloneThemeService } from '../common/standaloneThemeService.js';
import { MenuId, MenuRegistry } from '../../../platform/actions/common/actions.js';
import { CommandsRegistry, ICommandService } from '../../../platform/commands/common/commands.js';
import { IConfigurationService } from '../../../platform/configuration/common/configuration.js';
import { ContextKeyExpr, IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { IContextViewService, IContextMenuService } from '../../../platform/contextview/browser/contextView.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';
import { IKeybindingService } from '../../../platform/keybinding/common/keybinding.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { IThemeService } from '../../../platform/theme/common/themeService.js';
import { IAccessibilityService } from '../../../platform/accessibility/common/accessibility.js';
import { StandaloneCodeEditorNLS } from '../../common/standaloneStrings.js';
import { IClipboardService } from '../../../platform/clipboard/common/clipboardService.js';
import { IEditorProgressService } from '../../../platform/progress/common/progress.js';
var LAST_GENERATED_COMMAND_ID = 0;
var ariaDomNodeCreated = false;

function createAriaDomNode() {
  if (ariaDomNodeCreated) {
    return;
  }

  ariaDomNodeCreated = true;
  aria.setARIAContainer(document.body);
}
/**
 * A code editor to be used both by the standalone editor and the standalone diff editor.
 */


var StandaloneCodeEditor = /*#__PURE__*/function (_CodeEditorWidget) {
  _inherits(StandaloneCodeEditor, _CodeEditorWidget);

  var _super = _createSuper(StandaloneCodeEditor);

  function StandaloneCodeEditor(domElement, options, instantiationService, codeEditorService, commandService, contextKeyService, keybindingService, themeService, notificationService, accessibilityService) {
    var _this;

    _classCallCheck(this, StandaloneCodeEditor);

    options = options || {};
    options.ariaLabel = options.ariaLabel || StandaloneCodeEditorNLS.editorViewAccessibleLabel;
    options.ariaLabel = options.ariaLabel + ';' + StandaloneCodeEditorNLS.accessibilityHelpMessage;
    _this = _super.call(this, domElement, options, {}, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService);

    if (keybindingService instanceof StandaloneKeybindingService) {
      _this._standaloneKeybindingService = keybindingService;
    } else {
      _this._standaloneKeybindingService = null;
    } // Create the ARIA dom node as soon as the first editor is instantiated


    createAriaDomNode();
    return _this;
  }

  _createClass(StandaloneCodeEditor, [{
    key: "addCommand",
    value: function addCommand(keybinding, handler, context) {
      if (!this._standaloneKeybindingService) {
        console.warn('Cannot add command because the editor is configured with an unrecognized KeybindingService');
        return null;
      }

      var commandId = 'DYNAMIC_' + ++LAST_GENERATED_COMMAND_ID;
      var whenExpression = ContextKeyExpr.deserialize(context);

      this._standaloneKeybindingService.addDynamicKeybinding(commandId, keybinding, handler, whenExpression);

      return commandId;
    }
  }, {
    key: "createContextKey",
    value: function createContextKey(key, defaultValue) {
      return this._contextKeyService.createKey(key, defaultValue);
    }
  }, {
    key: "addAction",
    value: function addAction(_descriptor) {
      var _this2 = this;

      if (typeof _descriptor.id !== 'string' || typeof _descriptor.label !== 'string' || typeof _descriptor.run !== 'function') {
        throw new Error('Invalid action descriptor, `id`, `label` and `run` are required properties!');
      }

      if (!this._standaloneKeybindingService) {
        console.warn('Cannot add keybinding because the editor is configured with an unrecognized KeybindingService');
        return Disposable.None;
      } // Read descriptor options


      var id = _descriptor.id;
      var label = _descriptor.label;
      var precondition = ContextKeyExpr.and(ContextKeyExpr.equals('editorId', this.getId()), ContextKeyExpr.deserialize(_descriptor.precondition));
      var keybindings = _descriptor.keybindings;
      var keybindingsWhen = ContextKeyExpr.and(precondition, ContextKeyExpr.deserialize(_descriptor.keybindingContext));
      var contextMenuGroupId = _descriptor.contextMenuGroupId || null;
      var contextMenuOrder = _descriptor.contextMenuOrder || 0;

      var run = function run(accessor) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return Promise.resolve(_descriptor.run.apply(_descriptor, [_this2].concat(args)));
      };

      var toDispose = new DisposableStore(); // Generate a unique id to allow the same descriptor.id across multiple editor instances

      var uniqueId = this.getId() + ':' + id; // Register the command

      toDispose.add(CommandsRegistry.registerCommand(uniqueId, run)); // Register the context menu item

      if (contextMenuGroupId) {
        var menuItem = {
          command: {
            id: uniqueId,
            title: label
          },
          when: precondition,
          group: contextMenuGroupId,
          order: contextMenuOrder
        };
        toDispose.add(MenuRegistry.appendMenuItem(MenuId.EditorContext, menuItem));
      } // Register the keybindings


      if (Array.isArray(keybindings)) {
        var _iterator = _createForOfIteratorHelper(keybindings),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var kb = _step.value;
            toDispose.add(this._standaloneKeybindingService.addDynamicKeybinding(uniqueId, kb, run, keybindingsWhen));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Finally, register an internal editor action


      var internalAction = new InternalEditorAction(uniqueId, label, label, precondition, run, this._contextKeyService); // Store it under the original id, such that trigger with the original id will work

      this._actions[id] = internalAction;
      toDispose.add(toDisposable(function () {
        delete _this2._actions[id];
      }));
      return toDispose;
    }
  }]);

  return StandaloneCodeEditor;
}(CodeEditorWidget);

StandaloneCodeEditor = __decorate([__param(2, IInstantiationService), __param(3, ICodeEditorService), __param(4, ICommandService), __param(5, IContextKeyService), __param(6, IKeybindingService), __param(7, IThemeService), __param(8, INotificationService), __param(9, IAccessibilityService)], StandaloneCodeEditor);
export { StandaloneCodeEditor };

var StandaloneEditor = /*#__PURE__*/function (_StandaloneCodeEditor) {
  _inherits(StandaloneEditor, _StandaloneCodeEditor);

  var _super2 = _createSuper(StandaloneEditor);

  function StandaloneEditor(domElement, options, toDispose, instantiationService, codeEditorService, commandService, contextKeyService, keybindingService, contextViewService, themeService, notificationService, configurationService, accessibilityService) {
    var _this3;

    _classCallCheck(this, StandaloneEditor);

    applyConfigurationValues(configurationService, options, false);
    var themeDomRegistration = themeService.registerEditorContainer(domElement);
    options = options || {};

    if (typeof options.theme === 'string') {
      themeService.setTheme(options.theme);
    }

    var _model = options.model;
    delete options.model;
    _this3 = _super2.call(this, domElement, options, instantiationService, codeEditorService, commandService, contextKeyService, keybindingService, themeService, notificationService, accessibilityService);
    _this3._contextViewService = contextViewService;
    _this3._configurationService = configurationService;
    _this3._standaloneThemeService = themeService;

    _this3._register(toDispose);

    _this3._register(themeDomRegistration);

    var model;

    if (typeof _model === 'undefined') {
      model = self.monaco.editor.createModel(options.value || '', options.language || 'text/plain');
      _this3._ownsModel = true;
    } else {
      model = _model;
      _this3._ownsModel = false;
    }

    _this3._attachModel(model);

    if (model) {
      var e = {
        oldModelUrl: null,
        newModelUrl: model.uri
      };

      _this3._onDidChangeModel.fire(e);
    }

    return _this3;
  }

  _createClass(StandaloneEditor, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(StandaloneEditor.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(newOptions) {
      applyConfigurationValues(this._configurationService, newOptions, false);

      if (typeof newOptions.theme === 'string') {
        this._standaloneThemeService.setTheme(newOptions.theme);
      }

      _get(_getPrototypeOf(StandaloneEditor.prototype), "updateOptions", this).call(this, newOptions);
    }
  }, {
    key: "_attachModel",
    value: function _attachModel(model) {
      _get(_getPrototypeOf(StandaloneEditor.prototype), "_attachModel", this).call(this, model);

      if (this._modelData) {
        this._contextViewService.setContainer(this._modelData.view.domNode.domNode);
      }
    }
  }, {
    key: "_postDetachModelCleanup",
    value: function _postDetachModelCleanup(detachedModel) {
      _get(_getPrototypeOf(StandaloneEditor.prototype), "_postDetachModelCleanup", this).call(this, detachedModel);

      if (detachedModel && this._ownsModel) {
        detachedModel.dispose();
        this._ownsModel = false;
      }
    }
  }]);

  return StandaloneEditor;
}(StandaloneCodeEditor);

StandaloneEditor = __decorate([__param(3, IInstantiationService), __param(4, ICodeEditorService), __param(5, ICommandService), __param(6, IContextKeyService), __param(7, IKeybindingService), __param(8, IContextViewService), __param(9, IStandaloneThemeService), __param(10, INotificationService), __param(11, IConfigurationService), __param(12, IAccessibilityService)], StandaloneEditor);
export { StandaloneEditor };

var StandaloneDiffEditor = /*#__PURE__*/function (_DiffEditorWidget) {
  _inherits(StandaloneDiffEditor, _DiffEditorWidget);

  var _super3 = _createSuper(StandaloneDiffEditor);

  function StandaloneDiffEditor(domElement, options, toDispose, instantiationService, contextKeyService, keybindingService, contextViewService, editorWorkerService, codeEditorService, themeService, notificationService, configurationService, contextMenuService, editorProgressService, clipboardService) {
    var _this4;

    _classCallCheck(this, StandaloneDiffEditor);

    applyConfigurationValues(configurationService, options, true);
    var themeDomRegistration = themeService.registerEditorContainer(domElement);
    options = options || {};

    if (typeof options.theme === 'string') {
      options.theme = themeService.setTheme(options.theme);
    }

    _this4 = _super3.call(this, domElement, options, clipboardService, editorWorkerService, contextKeyService, instantiationService, codeEditorService, themeService, notificationService, contextMenuService, editorProgressService);
    _this4._contextViewService = contextViewService;
    _this4._configurationService = configurationService;
    _this4._standaloneThemeService = themeService;

    _this4._register(toDispose);

    _this4._register(themeDomRegistration);

    _this4._contextViewService.setContainer(_this4._containerDomElement);

    return _this4;
  }

  _createClass(StandaloneDiffEditor, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(StandaloneDiffEditor.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(newOptions) {
      applyConfigurationValues(this._configurationService, newOptions, true);

      if (typeof newOptions.theme === 'string') {
        this._standaloneThemeService.setTheme(newOptions.theme);
      }

      _get(_getPrototypeOf(StandaloneDiffEditor.prototype), "updateOptions", this).call(this, newOptions);
    }
  }, {
    key: "_createInnerEditor",
    value: function _createInnerEditor(instantiationService, container, options) {
      return instantiationService.createInstance(StandaloneCodeEditor, container, options);
    }
  }, {
    key: "getOriginalEditor",
    value: function getOriginalEditor() {
      return _get(_getPrototypeOf(StandaloneDiffEditor.prototype), "getOriginalEditor", this).call(this);
    }
  }, {
    key: "getModifiedEditor",
    value: function getModifiedEditor() {
      return _get(_getPrototypeOf(StandaloneDiffEditor.prototype), "getModifiedEditor", this).call(this);
    }
  }, {
    key: "addCommand",
    value: function addCommand(keybinding, handler, context) {
      return this.getModifiedEditor().addCommand(keybinding, handler, context);
    }
  }, {
    key: "createContextKey",
    value: function createContextKey(key, defaultValue) {
      return this.getModifiedEditor().createContextKey(key, defaultValue);
    }
  }, {
    key: "addAction",
    value: function addAction(descriptor) {
      return this.getModifiedEditor().addAction(descriptor);
    }
  }]);

  return StandaloneDiffEditor;
}(DiffEditorWidget);

StandaloneDiffEditor = __decorate([__param(3, IInstantiationService), __param(4, IContextKeyService), __param(5, IKeybindingService), __param(6, IContextViewService), __param(7, IEditorWorkerService), __param(8, ICodeEditorService), __param(9, IStandaloneThemeService), __param(10, INotificationService), __param(11, IConfigurationService), __param(12, IContextMenuService), __param(13, IEditorProgressService), __param(14, IClipboardService)], StandaloneDiffEditor);
export { StandaloneDiffEditor };